<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SfIconArrowBack } from '@storefront-ui/vue';

const props = defineProps<{
  category?: any;
}>();

const accordionValue = ref<string | undefined>();
</script>

<template>
<Accordion v-model:model-value="accordionValue" type="single" collapsible>
    <AccordionItem value="item-1" class="py-3 border-b">
        <div class="flex flex-col gap-3 text-sm">
            <div class="flex items-center justify-between cursor-pointer">
            <span class="uppercase font-bold">{{ $t('Categories') }}</span>
            </div>
            
            <div v-if="category" class="select-none flex flex-col gap-2 text-sm pb-0">
                <NuxtLink
                    v-if="category.parent"
                    :to="category.parent.url"
                    :aria-label="category.parent.name"
                    class="whitespace-pre-wrap flex gap-2 items-center hover:text-gray-700"
                >
                    <SfIconArrowBack class="text-neutral-500 !w-5 !h-5" />
                    <p>{{ category.parent.name }}</p>
                </NuxtLink>

                <NuxtLink
                    :to="category.url"
                    :aria-label="category.name"
                    class="whitespace-pre-wrap flex gap-2 items-center font-semibold text-primary"
                >
                    {{ category.name }}
                </NuxtLink>

                <div v-if="category.children?.length" class="pl-5 flex flex-col gap-2">
                    <NuxtLink
                    v-for="child in category.children.slice(0, 4)"
                    :key="child.url"
                    :to="child.url"
                    :aria-label="child.label"
                    class="whitespace-pre-wrap flex items-center font-medium"
                    >
                    {{ child.name }}
                    </NuxtLink>

                    <AccordionContent v-if="category.children.length > 4">
                        <div class="flex flex-col gap-2">
                            <NuxtLink
                            v-for="child in category.children.slice(4)"
                            :key="child.url"
                            :to="child.url"
                            :aria-label="child.label"
                            class="whitespace-pre-wrap flex items-center font-medium"
                            >
                            {{ child.name }}
                            </NuxtLink>
                        </div>
                    </AccordionContent>
                </div>
            </div>
        </div>
      
        <AccordionTrigger
            v-if="category?.children?.length > 4"
            class="!text-xs text-primary font-semibold pt-2 pb-0 cursor-pointer"
        >
            {{ accordionValue === 'item-1' ? $t('products.show_less') : $t('products.show_more') }}
        </AccordionTrigger>
    </AccordionItem>
</Accordion>
</template>